import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  title: {
    background: '#004a83',
    color: theme.palette.getContrastText('#004a83'),
    padding: 10,
  },
  container: {
    padding: 20,
  }
}))

function Widget({ children, title, noPadding }) {
  const classes = useStyles();
  return (
    <Paper>
      {title && (
        <Typography
          className={classes.title}
          padding="none"
          gutterBottom
        >
          {title}
        </Typography>
      )}
      <div className={clsx({ [classes.container]: !noPadding })}>
        { children }
      </div>
    </Paper>
  )
}

Widget.propTypes = {
  noPadding: PropTypes.bool,
}

Widget.defaultProps = {
  noPadding: false,
}

export default Widget;
